// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "main") return "react/css/bundle." + __webpack_require__.h() + ".css";
	// return url for filenames based on template
	return "react/css/" + chunkId + "." + __webpack_require__.h() + ".css";
};